module.exports = __webpack_public_path__ + "static/img/advice_success_bg.74a230b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advice/advice_success_bg.png
// module id = opA8
// module chunks = 1